import React, { useState, useEffect } from 'react';
import { FORNECEDORES, ARLA, CART_IDS, hasPE, hasAditivo, embs, getSaldo, getUreiaSaldos, arlaByUnit } from '../constants';

export default function Lancamento({ lancamentos, carteira, unit, isAdmin, onSave, editingDate, onCancelEdit }) {
  const isEdit = !!editingDate;
  const lastDay = lancamentos[lancamentos.length - 1] || null;
  const editDay = isEdit ? lancamentos.find(d => d.data === editingDate) || null : null;
  const sourceDay = isEdit ? editDay : lastDay;
  const s = sourceDay ? getSaldo(sourceDay, unit) : null;
  const embList = embs(unit);
  const arlaList = arlaByUnit(unit);
  const [showModal, setShowModal] = useState(false);

  // Data do lançamento — hoje por padrão, editável (máx 4 dias atrás)
  const todayStr = new Date().toISOString().split('T')[0];
  const minDateStr = isAdmin ? '2025-01-01' : (() => {
  const d = new Date(); d.setDate(d.getDate() - 4);
  return d.toISOString().split('T')[0];
  })();
  const [dataLancamento, setDataLancamento] = useState(isEdit ? editingDate : todayStr);

  const initPE = () => ({
    saldo_ini: isEdit ? editDay?.pe?.saldo_ini ?? 0 : s?.peSaldo ?? 0,
    entrada: isEdit ? editDay?.pe?.entrada ?? 0 : 0,
    consumo: isEdit ? editDay?.pe?.consumo ?? 0 : 0,
  });

  const initAditivo = () => ({
    saldo_ini: isEdit ? editDay?.aditivo?.saldo_ini ?? 0 : s?.aditivoSaldo ?? 0,
    entrada:   isEdit ? editDay?.aditivo?.entrada ?? 0 : 0,
    consumo:   isEdit ? editDay?.aditivo?.consumo ?? 0 : 0,
  });

  const initUreia = () => {
    const o = {};
    const prevSaldos = sourceDay ? getUreiaSaldos(sourceDay) : {};
    FORNECEDORES.forEach(f => {
      if (isEdit && editDay?.ureia?.[f.id] && typeof editDay.ureia[f.id] === 'object') {
        o[f.id] = { ...editDay.ureia[f.id] };
      } else {
        o[f.id] = { saldo_ini: prevSaldos[f.id] || 0, entrada: 0, consumo: 0 };
      }
    });
    return o;
  };

  const initEmb = () => {
    const o = {};
    embList.forEach(e => {
      o[e.id] = {
        saldo_ini: isEdit ? editDay?.emb?.[e.id]?.saldo_ini ?? 0 : s?.emb[e.id] ?? 0,
        entrada:   isEdit ? editDay?.emb?.[e.id]?.entrada ?? 0 : 0,
        saida:     isEdit ? editDay?.emb?.[e.id]?.saida ?? 0 : 0,
      };
    });
    return o;
  };

  const initArla = () => {
    const o = {};
    ARLA.forEach(p => {
      o[p.id] = {
        saldo_ini: isEdit ? editDay?.arla?.[p.id]?.saldo_ini ?? 0 : s?.arla[p.id] ?? 0,
        producao:  isEdit ? editDay?.arla?.[p.id]?.producao ?? 0 : 0,
        saida:     isEdit ? editDay?.arla?.[p.id]?.saida ?? 0 : 0,
      };
    });
    return o;
  };

  const initCart = () => {
    const o = {};
    CART_IDS.forEach(id => { o[id] = carteira[id] ?? 0; });
    return o;
  };

  const [pe, setPE]           = useState(initPE);
  const [aditivo, setAditivo] = useState(initAditivo);
  const [ureia, setUreia]     = useState(initUreia);
  const [emb, setEmb]         = useState(initEmb);
  const [arla, setArla]       = useState(initArla);
  const [cart, setCart]       = useState(initCart);
  const [saving, setSaving]   = useState(false);

  useEffect(() => {
    setPE(initPE()); setAditivo(initAditivo()); setUreia(initUreia()); setEmb(initEmb()); setArla(initArla()); setCart(initCart());
    setDataLancamento(isEdit ? editingDate : todayStr);
  }, [editingDate, lancamentos]);

  const peSaldo  = hasPE(unit) ? (pe.saldo_ini || 0) + (pe.entrada || 0) - (pe.consumo || 0) : 0;
  const pePot    = Math.round(peSaldo / 0.89);
  const urTotal  = FORNECEDORES.reduce((sum, f) => sum + (Number(ureia[f.id]?.saldo_ini || 0) + Number(ureia[f.id]?.entrada || 0) - Number(ureia[f.id]?.consumo || 0)), 0);
  const urPot    = Math.round(urTotal / 0.36);

  const handleConfirm = async () => {
    setSaving(true);
    const prevFatAcum = (isEdit ? editDay : lastDay)?.fatAcum || {};
    const fatAcum = {};
    ARLA.forEach(p => { fatAcum[p.id] = (prevFatAcum[p.id] || 0) + (arla[p.id].saida || 0); });
    const dados = { pe: hasPE(unit) ? pe : null, aditivo: hasAditivo(unit) ? aditivo : null, ureia, emb, arla, fatAcum };
    await onSave(dados, cart, dataLancamento);
    setSaving(false);
    setShowModal(false);
  };

  const handleSave = () => {
    if (isEdit) { handleConfirm(); return; }
    setShowModal(true);
  };

  const Modal = () => {
    const arlaItems = ARLA.filter(p => ['bomb20','bomb5','ibc1000','granel'].includes(p.id));
    return (
      <div style={S.overlay}>
        <div style={S.modal}>
          <div style={S.modalHeader}>
            <div style={S.modalTitle}>Confirmar lançamento</div>
            <div style={S.modalSub}>Revise os dados antes de salvar. Após confirmação, um e-mail será enviado ao administrador.</div>
          </div>

          <div style={S.modalBody}>
            {hasPE(unit) && (
              <div style={S.resumoSection}>
                <div style={S.resumoLabel}>Polietileno</div>
                <div style={S.resumoRow}><span>Saldo atual</span><span style={S.resumoVal}>{Math.round(peSaldo).toLocaleString('pt-BR')} kg</span></div>
                <div style={S.resumoRow}><span>Potencial embalagens</span><span style={S.resumoVal}>{Math.round(pePot).toLocaleString('pt-BR')} un</span></div>
              </div>
            )}

            <div style={S.resumoSection}>
              <div style={S.resumoLabel}>Ureia</div>
              {FORNECEDORES.map(f => {
                const saldo = (ureia[f.id]?.saldo_ini || 0) + (ureia[f.id]?.entrada || 0) - (ureia[f.id]?.consumo || 0);
                if (!saldo) return null;
                return <div key={f.id} style={S.resumoRow}><span>{f.label}</span><span style={S.resumoVal}>{Math.round(saldo).toLocaleString('pt-BR')} kg</span></div>;
              })}
              <div style={{ ...S.resumoRow, fontWeight: 600 }}><span>Total</span><span style={S.resumoVal}>{Math.round(urTotal).toLocaleString('pt-BR')} kg</span></div>
            </div>

            <div style={S.resumoSection}>
              <div style={S.resumoLabel}>Arla — Estoque</div>
              {arlaItems.map(p => {
                const saldo = (arla[p.id]?.saldo_ini || 0) + (arla[p.id]?.producao || 0) - (arla[p.id]?.saida || 0);
                const ct = cart[p.id] || 0;
                const aProd = ct - saldo;
                return (
                  <div key={p.id} style={S.resumoRow}>
                    <span>{p.label}</span>
                    <span style={{ ...S.resumoVal, color: ct > 0 ? (aProd > 0 ? '#b91c1c' : '#1a5c38') : '#1a1a18' }}>
                      {Math.round(saldo).toLocaleString('pt-BR')} {p.unit}
                      {ct > 0 && <span style={{ fontSize: 11, marginLeft: 6, color: '#aaa' }}>cart: {Math.round(ct).toLocaleString('pt-BR')}</span>}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          <div style={S.modalActions}>
            <button style={S.btnSecondary} onClick={() => setShowModal(false)}>Revisar dados</button>
            <button style={S.btnPrimary} onClick={handleConfirm} disabled={saving}>
              {saving ? 'Salvando...' : '✓ Confirmar e enviar'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const n = (hasPE(unit) ? 1 : 0) + (hasAditivo(unit) ? 1 : 0) + 1;

  return (
    <div>
      {showModal && <Modal />}
      {isEdit && (
        <div style={S.banner}>
          <span>Editando lançamento de <b>{new Date(editingDate + 'T12:00:00').toLocaleDateString('pt-BR')}</b></span>
          <button style={S.btnSm} onClick={onCancelEdit}>Cancelar edição</button>
        </div>
      )}
      <p style={S.hint}>{isEdit ? 'Corrija os campos e salve.' : 'Registre os dados do dia anterior. Saldos iniciais preenchidos automaticamente.'}</p>

      {/* Data do lançamento */}
      {!isEdit && (
        <div style={{ ...S.section, display: 'flex', alignItems: 'center', gap: 16, padding: '12px 16px' }}>
          <div style={{ fontSize: 13, fontWeight: 500, color: '#555', fontFamily: '"DM Sans", sans-serif' }}>
            Data de referência do lançamento:
          </div>
          <input
            type="date"
            value={dataLancamento}
            min={minDateStr}
            max={todayStr}
            onChange={e => setDataLancamento(e.target.value)}
            style={{ ...S.input, width: 'auto', fontFamily: '"DM Sans", sans-serif', fontSize: 13 }}
          />
          <span style={{ fontSize: 12, color: '#aaa', fontFamily: '"DM Sans", sans-serif' }}>
            (máx. 4 dias atrás)
          </span>
        </div>
      )}

      {/* Polietileno — só CV */}
      {hasPE(unit) && (
        <div style={S.section}>
          <div style={S.secTitle}>1 — Polietileno</div>
          <div style={S.grid3}>
            <Field label={`Saldo inicial${isEdit ? '' : ' (auto)'}`} unit="kg">
              <NumInput style={{ ...S.input, ...(isEdit ? {} : S.inputRo) }} value={pe.saldo_ini} readOnly={!isEdit}
                onChange={v => setPE(p => ({ ...p, saldo_ini: v }))} />
            </Field>
            <Field label="Entradas" unit="kg">
              <NumInput style={S.input} value={pe.entrada} onChange={v => setPE(p => ({ ...p, entrada: v }))} />
            </Field>
            <Field label="Consumo" unit="kg">
              <NumInput style={S.input} value={pe.consumo} onChange={v => setPE(p => ({ ...p, consumo: v }))} />
            </Field>
          </div>
          <div style={{ ...S.grid3, marginTop: 10 }}>
            <Field label="Saldo atual" unit="kg">
              <NumInput style={{ ...S.input, ...S.inputRo }} value={peSaldo} readOnly onChange={() => {}} />
            </Field>
            <Field label="Potencial" unit="un emb">
              <NumInput style={{ ...S.input, ...S.inputRo }} value={pePot} readOnly onChange={() => {}} />
            </Field>
          </div>
        </div>
      )}

      {/* Aditivo — só CV */}
      {hasAditivo(unit) && (
        <div style={S.section}>
          <div style={S.secTitle}>2 — Aditivo</div>
          <div style={S.grid3}>
            <Field label={`Saldo inicial${isEdit ? '' : ' (auto)'}`} unit="L">
              <NumInput style={{ ...S.input, ...(isEdit ? {} : S.inputRo) }} value={aditivo.saldo_ini} readOnly={!isEdit}
                onChange={v => setAditivo(a => ({ ...a, saldo_ini: v }))} />
            </Field>
            <Field label="Entradas" unit="L">
              <NumInput style={S.input} value={aditivo.entrada} onChange={v => setAditivo(a => ({ ...a, entrada: v }))} />
            </Field>
            <Field label="Consumo" unit="L">
              <NumInput style={S.input} value={aditivo.consumo} onChange={v => setAditivo(a => ({ ...a, consumo: v }))} />
            </Field>
          </div>
          <div style={{ ...S.grid3, marginTop: 10 }}>
            <Field label="Saldo atual" unit="L">
              <NumInput style={{ ...S.input, ...S.inputRo }}
                value={(aditivo.saldo_ini||0) + (aditivo.entrada||0) - (aditivo.consumo||0)}
                readOnly onChange={() => {}} />
            </Field>
          </div>
        </div>
      )}

      {/* Ureia */}
      <div style={S.section}>
        <div style={S.secTitle}>{n} — Ureia por fornecedor</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 10 }}>
          {FORNECEDORES.map(f => (
            <div key={f.id} style={S.subCard}>
              <div style={S.subCardTitle}>{f.label}</div>
              <Field label="Saldo anterior" unit="kg">
                <NumInput style={{ ...S.input, ...(isEdit ? {} : S.inputRo) }}
                  value={ureia[f.id]?.saldo_ini || 0} readOnly={!isEdit}
                  onChange={v => setUreia(u => ({ ...u, [f.id]: { ...u[f.id], saldo_ini: v } }))} />
              </Field>
              <Field label="Entrada/Compra" unit="kg">
                <NumInput style={S.input} value={ureia[f.id]?.entrada || 0}
                  onChange={v => setUreia(u => ({ ...u, [f.id]: { ...u[f.id], entrada: v } }))} />
              </Field>
              <Field label="Consumo" unit="kg">
                <NumInput style={S.input} value={ureia[f.id]?.consumo || 0}
                  onChange={v => setUreia(u => ({ ...u, [f.id]: { ...u[f.id], consumo: v } }))} />
              </Field>
              <Field label="Saldo atual" unit="kg">
                <NumInput style={{ ...S.input, ...S.inputRo }} readOnly onChange={() => {}}
                  value={(ureia[f.id]?.saldo_ini || 0) + (ureia[f.id]?.entrada || 0) - (ureia[f.id]?.consumo || 0)} />
              </Field>
            </div>
          ))}
        </div>
        <div style={{ ...S.grid3, marginTop: 10 }}>
          <Field label="Total ureia" unit="kg">
            <NumInput style={{ ...S.input, ...S.inputRo }} value={urTotal} readOnly onChange={() => {}} />
          </Field>
          <Field label="Potencial Arla" unit="L">
            <NumInput style={{ ...S.input, ...S.inputRo }} value={urPot} readOnly onChange={() => {}} />
          </Field>
        </div>
      </div>

      {/* Embalagens */}
      <div style={S.section}>
        <div style={S.secTitle}>{n + 1} — Embalagens</div>
        <div style={S.grid4}>
          {embList.map(e => (
            <div key={e.id} style={S.subCard}>
              <div style={S.subCardTitle}>
                {e.label}
                <span style={e.produz ? S.badgeOk : S.badgeGray}>{e.produz ? 'Produção' : 'Compra'}</span>
              </div>
              <Field label="Saldo inicial" unit={e.unit}>
                <NumInput style={{ ...S.input, ...(isEdit ? {} : S.inputRo) }}
                  value={emb[e.id]?.saldo_ini || 0} readOnly={!isEdit}
                  onChange={v => setEmb(m => ({ ...m, [e.id]: { ...m[e.id], saldo_ini: v } }))} />
              </Field>
              <Field label={e.produz ? 'Produção' : 'Compra/Entrada'} unit={e.unit}>
                <NumInput style={S.input} value={emb[e.id]?.entrada || 0}
                  onChange={v => setEmb(m => ({ ...m, [e.id]: { ...m[e.id], entrada: v } }))} />
              </Field>
              <Field label="Saída/Consumo" unit={e.unit}>
                <NumInput style={S.input} value={emb[e.id]?.saida || 0}
                  onChange={v => setEmb(m => ({ ...m, [e.id]: { ...m[e.id], saida: v } }))} />
              </Field>
            </div>
          ))}
        </div>
      </div>

      {/* Arla */}
      <div style={S.section}>
        <div style={S.secTitle}>{n + 2} — Produção de Arla</div>
        <div style={S.grid3}>
          {arlaList.map(p => (
            <div key={p.id} style={S.subCard}>
              <div style={S.subCardTitle}>{p.label}</div>
              <Field label="Saldo anterior" unit={p.unit}>
                <NumInput style={{ ...S.input, ...(isEdit ? {} : S.inputRo) }}
                  value={arla[p.id]?.saldo_ini || 0} readOnly={!isEdit}
                  onChange={v => setArla(a => ({ ...a, [p.id]: { ...a[p.id], saldo_ini: v } }))} />
              </Field>
              <Field label="Produção" unit={p.unit}>
                <NumInput style={S.input} value={arla[p.id]?.producao || 0}
                  onChange={v => setArla(a => ({ ...a, [p.id]: { ...a[p.id], producao: v } }))} />
              </Field>
              <Field label="Saída/Fat." unit={p.unit}>
                <NumInput style={S.input} value={arla[p.id]?.saida || 0}
                  onChange={v => setArla(a => ({ ...a, [p.id]: { ...a[p.id], saida: v } }))} />
              </Field>
            </div>
          ))}
        </div>
      </div>

      {/* Carteira */}
      <div style={S.section}>
        <div style={S.secTitle}>{n + 3} — Carteira de pedidos</div>
        <div style={S.grid4}>
          {CART_IDS.map(id => {
            const p = ARLA.find(x => x.id === id);
            return (
              <Field key={id} label={p.label} unit={p.unit}>
                <NumInput style={S.input} value={cart[id] || 0}
                  onChange={v => setCart(c => ({ ...c, [id]: v }))} />
              </Field>
            );
          })}
        </div>
      </div>

      <div style={S.actions}>
        <button style={S.btnSecondary} onClick={isEdit ? onCancelEdit : () => window.location.reload()}>
          {isEdit ? 'Cancelar' : 'Limpar'}
        </button>
        <button style={S.btnPrimary} onClick={handleSave} disabled={saving}>
          {saving ? 'Salvando...' : isEdit ? 'Salvar correção' : 'Salvar lançamento'}
        </button>
      </div>
    </div>
  );
}

function Field({ label, unit, children }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 8 }}>
      <label style={{ fontSize: 12, color: '#888', fontWeight: 500, fontFamily: '"DM Sans", sans-serif' }}>
        {label} <span style={{ fontSize: 10, color: '#bbb' }}>{unit}</span>
      </label>
      {children}
    </div>
  );
}

// Input numérico com formatação de milhar
function NumInput({ value, onChange, readOnly, style }) {
  const [focused, setFocused] = React.useState(false);
  const displayVal = focused
    ? (value === 0 ? '' : String(value))
    : (value ? Math.round(value).toLocaleString('pt-BR') : '0');

  return (
    <input
      type="text"
      inputMode="numeric"
      value={displayVal}
      readOnly={readOnly}
      style={style}
      onFocus={() => setFocused(true)}
      onBlur={(e) => {
        setFocused(false);
        const raw = e.target.value.replace(/\./g, '').replace(',', '.');
        const num = parseFloat(raw) || 0;
        onChange(num);
      }}
      onChange={(e) => {
        if (focused) {
          const raw = e.target.value.replace(/[^\d]/g, '');
          onChange(parseFloat(raw) || 0);
        }
      }}
    />
  );
}

const S = {
  hint: { fontSize: 12, color: '#aaa', marginBottom: 14, fontFamily: '"DM Sans", sans-serif' },
  banner: { background: '#eff6ff', border: '0.5px solid #bfdbfe', borderRadius: 8, padding: '10px 14px', marginBottom: 14, display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: 13, color: '#1d4ed8', fontFamily: '"DM Sans", sans-serif' },
  section: { background: '#fff', border: '0.5px solid #e8e6e0', borderRadius: 10, padding: 16, marginBottom: 14 },
  secTitle: { fontSize: 11, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 12, paddingBottom: 8, borderBottom: '0.5px solid #e8e6e0', fontFamily: '"DM Sans", sans-serif' },
  grid3: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 },
  grid4: { display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 10 },
  input: { border: '0.5px solid #e0ddd6', borderRadius: 6, padding: '7px 10px', fontSize: 13, fontFamily: '"DM Sans", sans-serif', background: '#fafaf8', color: '#1a1a18', width: '100%', boxSizing: 'border-box' },
  inputRo: { background: '#f0ede8', color: '#999' },
  subCard: { background: '#f8f7f3', border: '0.5px solid #e8e6e0', borderRadius: 8, padding: 12 },
  subCardTitle: { fontSize: 12, fontWeight: 600, color: '#1a1a18', marginBottom: 10, fontFamily: '"DM Sans", sans-serif', display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' },
  badgeOk:   { background: '#eaf3de', color: '#1a5c38', fontSize: 10, padding: '2px 6px', borderRadius: 4, fontWeight: 500 },
  badgeGray: { background: '#e8e6e0', color: '#888', fontSize: 10, padding: '2px 6px', borderRadius: 4, fontWeight: 500 },
  actions: { display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 6 },
  btnPrimary:   { background: '#1a5c38', color: '#fff', border: 'none', borderRadius: 7, padding: '10px 22px', fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: '"DM Sans", sans-serif' },
  btnSecondary: { background: '#fff', color: '#555', border: '0.5px solid #e0ddd6', borderRadius: 7, padding: '10px 22px', fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: '"DM Sans", sans-serif' },
  btnSm: { background: '#fff', color: '#555', border: '0.5px solid #e0ddd6', borderRadius: 6, padding: '5px 12px', fontSize: 12, cursor: 'pointer', fontFamily: '"DM Sans", sans-serif' },
  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 },
  modal: { background: '#fff', borderRadius: 12, width: '100%', maxWidth: 480, maxHeight: '90vh', overflow: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' },
  modalHeader: { padding: '20px 24px 16px', borderBottom: '0.5px solid #e8e6e0' },
  modalTitle: { fontSize: 17, fontWeight: 600, color: '#1a1a18', fontFamily: '"DM Sans", sans-serif', marginBottom: 6 },
  modalSub: { fontSize: 12, color: '#888', fontFamily: '"DM Sans", sans-serif', lineHeight: 1.5 },
  modalBody: { padding: '16px 24px' },
  modalActions: { padding: '16px 24px', borderTop: '0.5px solid #e8e6e0', display: 'flex', gap: 10, justifyContent: 'flex-end' },
  resumoSection: { marginBottom: 16, paddingBottom: 16, borderBottom: '0.5px solid #f0ede8' },
  resumoLabel: { fontSize: 11, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8, fontFamily: '"DM Sans", sans-serif' },
  resumoRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 13, color: '#1a1a18', fontFamily: '"DM Sans", sans-serif', padding: '3px 0' },
  resumoVal: { fontWeight: 500, fontFamily: '"DM Mono", monospace', fontSize: 12 },
};
